import { useState } from "react"
import { BsFillArrowRightSquareFill } from 'react-icons/bs'
import { Link } from "react-router-dom"
import { GoTasklist } from 'react-icons/go'
import { MdSpaceDashboard } from 'react-icons/md'
import { useContext } from "react"
import { AuthContext } from '../../authContext/AuthContext'
import { FaUsers } from 'react-icons/fa'
import { MdOutlineSettingsInputComponent } from 'react-icons/md'
import { RiUser2Fill } from "react-icons/ri"
import { ImStatsDots } from "react-icons/im"
import { TbDeviceWatchStats } from "react-icons/tb"

const links = [
   {
      title: 'Dashboard',
      icon: <MdSpaceDashboard className="flex-shrink-0 w-6 h-6 text-gray-700 transition duration-75" />,
      to: '/'
   },
   {
      title: 'Employees',
      icon: <FaUsers className="flex-shrink-0 w-6 h-6 text-gray-700 transition duration-75 " />,
      to: '/employees'
   },
   {
      title: 'Employees Stats',
      icon: <TbDeviceWatchStats className="flex-shrink-0 w-6 h-6 text-gray-700 transition duration-75 " />,
      to: '/employees/stats'
   },
   {
      title: 'Jobs',
      icon: <GoTasklist className="flex-shrink-0 w-6 h-6 text-gray-700 transition duration-75 " />,
      to: '/jobs'
   },
   {
      title: 'Machines',
      icon: <MdOutlineSettingsInputComponent className="flex-shrink-0 w-6 h-6 text-gray-700 transition duration-75 " />,
      to: '/machines'
   },
   {
      title: 'Machines Stats',
      icon: <ImStatsDots className="flex-shrink-0 w-6 h-6 text-gray-700 transition duration-75 " />,
      to: '/machines/stats'
   },
]

const Sidebar = ({ currentPage }) => {
   const [toggle, setToggle] = useState(false)
   const [filteredLinks, setFilteredLinks] = useState(links)
   const { dispatch } = useContext(AuthContext)

   const handleLogOut = () => {
      localStorage.removeItem('currentUser')
      dispatch({
         type: 'LOGOUT'
      })
   }
   const handleSearchChange = (e) => {
      setFilteredLinks(links.filter(l => !l.title.toLowerCase().indexOf(e.target.value.toLowerCase())))
   }

   return (
      <>
         <aside className={`${toggle ? 'left-0' : '-left-72'} overflow-hidden rounded-lg fixed w-64 top-[50px] transition-all duration-300 lg:sticky h-[calc(100vh-73px)] mt-[11px] ml-[6px] bg-white z-40 shadow`} aria-label="Sidebar" >
            <div className="overflow-y-hidden pt-4 flex flex-col h-full">
               <div className='mx-3 flex bg-gray-50 px-2 py-[8px] active:scale-95 transition-all duration-200 rounded-md mb-3 border-2 border-transparent shadow  focus-within:border-red-500'>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 opacity-50">
                     <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                  </svg>
                  <div className="w-2" />
                  <input type="text" placeholder="Search" onChange={handleSearchChange} className="bg-transparent max-w-[185px] flex-1 outline-none placeholder-gray-600 placeholder-opacity-70 rounded-lg" />
               </div>
               <ul className="space-y-2 hover:overflow-y-auto flex-1 px-3 sidebar__Links">
                  {filteredLinks.map((link) => (
                     <li key={link.to}>
                        <Link to={link.to} className={`flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-700 hover:bg-gray-100 ${currentPage === link.title && 'bg-gray-100 shadow'}`}>
                           <span className='bg-white p-1 rounded shadow'>{link.icon}</span>
                           <span className="ml-3">{link.title}</span>
                        </Link>
                     </li>
                  ))}
                  {filteredLinks.length === 0 && (
                     <div className="w-full text-xs text-slate-400">Sorry, no links found related to given input.</div>
                  )}
                  <div className="py-1">
                     <div className="w-full border-t border-gray-300"></div>
                  </div>
                  {/* <hr className="text-slate-200" /> */}
                  <li>
                     <a href="https://employee-machine.netlify.app" target='blank' className="w-full text-left flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-gray-700 hover:bg-gray-200">
                        <RiUser2Fill className='flex-shrink-0 w-8 h-8 text-gray-700 transition duration-75 bg-white p-1 rounded shadow' />
                        <span className="flex-1 ml-3 whitespace-nowrap font-semibold">Employee log in</span>
                     </a>
                  </li>
                  <li>
                     <button onClick={handleLogOut} className="w-full text-left flex items-center p-2 text-base font-normal text-gray-900 rounded-lg dark:text-gray-700 hover:bg-gray-200">
                        <svg className="flex-shrink-0 w-8 h-8 text-gray-700 transition duration-7 bg-white p-1 rounded shadow" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd"></path></svg>
                        <span className="flex-1 ml-3 whitespace-nowrap font-semibold">Log out</span>
                     </button>
                  </li>
               </ul>
            </div>
         </aside>
         <button className={`left-3 z-40 ${toggle ? 'text-gray-700 rotate-180 left-52' : ''} fixed bottom-8 text-3xl transition-all duration-[1s] lg:hidden`} onClick={() => setToggle(!toggle)}><BsFillArrowRightSquareFill /></button>
      </>
   )
}

export default Sidebar